import React from 'react'

import * as S from './styles'

export type ActionProps = {
  back?: {
    handler?: () => void
    label?: string
    to?: string
  }
  next: string
}

export const Action = ({ back, next, ...props }: ActionProps) => {
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <S.Container
      {...(back && {
        onCancel: {
          label: back.label || 'Voltar',
          to: back.to,
          onClick: back.handler,
        },
      })}
      onSubmit={{
        label: next,
        icon: 'arrow-right',
        onClick: goToTop,
      }}
    />
  )
}
